<template>
    <main class="grace-container">
        <section class="slogan">
            <div class="slogan-img"></div>
            <div class="main-title-wrapper">
                <div class="main-title">{{ $t('lp-grace1') }}</div>
            </div>

            <div class="vindome-app-icon"></div>
        </section>

        <div id="download" class="main-subtitle">{{ $t('lp-grace2') }}</div>
        <div class="download-btn-wrapper">
            <a v-on:click="() => { storeClick(true) }" href="https://apps.apple.com/app/vindome-wine/id1494570524" target="_blank" class="home-download-ios"></a>
            <a v-on:click="() => { storeClick(false) }" href="https://play.google.com/store/apps/details?id=com.vindome.wine" target="_blank" class="home-download-android"></a>
        </div>

        <section class="featured">
            <div class="mobileapp-container">
                <h2 class="home-title-wine">{{ $t('lp-grace3') }}</h2>

                <swiper :options="mobileCheck ? swiperOptionMobile : swiperOption">
                    <swiper-slide v-for="(item, index) in $i18n.locale === 'it' ? swiperDataIT : swiperData" :key="index">
                        <div v-on:click="showPrivacy(item.article)" class="article-text">
                            <div :class="'testimonial-logo logo-' + item.name"></div>
                            <div class="testimonial-info" v-html="item.value"></div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </section>

        <h2 class="home-title-wine">{{ $t('lp-grace4') }}</h2>
        <div class="mobileapp-container" v-if="!mobileCheck">
            <div class="how-it-works-row">
                <div class="how-it-works-row-left"></div>
                <div class="how-it-works-row-center icon1"></div>
                <div class="how-it-works-row-right">
                    <div class="how-title how-title1">{{ $t('lp-grace5') }}</div>
                    <div class="how-subtitle">{{ $t('lp-grace6') }}</div>
                </div>
            </div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row">
                <div class="how-it-works-row-left">
                    <div class="how-title">{{ $t('lp-grace7-1') }}</div>
                    <div class="how-subtitle">{{ $t('lp-grace8') }}</div>
                </div>
                <div class="how-it-works-row-center icon2"></div>
                <div class="how-it-works-row-right"></div>
            </div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row">
                <div class="how-it-works-row-left"></div>
                <div class="how-it-works-row-center icon3"></div>
                <div class="how-it-works-row-right">
                    <div class="how-title">{{ $t('lp-grace9') }}</div>
                    <div class="how-subtitle">{{ $t('lp-grace10') }}</div>
                </div>
            </div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row">
                <div class="how-it-works-row-left">
                    <div class="how-title">{{ $t('lp-grace11') }}</div>
                    <div class="how-subtitle">{{ $t('lp-grace12') }}</div>
                </div>
                <div class="how-it-works-row-center icon4"></div>
                <div class="how-it-works-row-right"></div>
            </div>

            <div class="start-btn" v-on:click="goToDownload">{{ $t('lp-grace13') }}</div>
        </div>
        <div class="mobileapp-container" v-else>
            <div class="how-it-works-row-center icon1"></div>
            <div class="how-title how-title1">{{ $t('lp-grace5') }}</div>
            <div class="how-subtitle">{{ $t('lp-grace6') }}</div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row-center icon2"></div>
            <div class="how-title">{{ $t('lp-grace7') }}</div>
            <div class="how-subtitle">{{ $t('lp-grace8') }}</div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row-center icon3"></div>
            <div class="how-title">{{ $t('lp-grace9') }}</div>
            <div class="how-subtitle">{{ $t('lp-grace10') }}</div>
            <div>
                <div class="dash"></div>
            </div>
            <div class="how-it-works-row-center icon4"></div>
            <div class="how-title">{{ $t('lp-grace11') }}</div>
            <div class="how-subtitle">{{ $t('lp-grace12') }}</div>
            <div class="start-btn" v-on:click="goToDownload">{{ $t('lp-grace13') }}</div>
        </div>

        <section class="featured last-section">
            <div class="mobileapp-container" v-if="!mobileCheck">
                <h2 class="home-title-wine">{{ $t('lp-grace14') }}</h2>

                <div class="invest-row">
                    <div class="invest-box">
                        <div class="invest-icon invest-icon1"></div>
                        <div class="invest-title">{{ $t('lp-grace15') }}</div>
                        <div class="invest-text">{{ $t('lp-grace16') }}</div>
                    </div>
                    <div class="invest-box">
                        <div class="invest-icon invest-icon2"></div>
                        <div class="invest-title">{{ $t('lp-grace17') }}</div>
                        <div class="invest-text">{{ $t('lp-grace18') }}</div>
                    </div>
                    <div class="invest-box">
                        <div class="invest-icon invest-icon3"></div>
                        <div class="invest-title">{{ $t('lp-grace19') }}</div>
                        <div class="invest-text">{{ $t('lp-grace20') }}</div>
                    </div>
                </div>

                <div class="invest-row">
                    <div class="invest-box">
                        <div class="invest-icon invest-icon4"></div>
                        <div class="invest-title">{{ $t('lp-grace21') }}</div>
                        <div class="invest-text">{{ $t('lp-grace22') }}</div>
                    </div>
                    <div class="invest-box">
                        <div class="invest-icon invest-icon5"></div>
                        <div class="invest-title">{{ $t('lp-grace23') }}</div>
                        <div class="invest-text">{{ $t('lp-grace24') }}</div>
                    </div>
                    <div class="invest-box">
                        <div class="invest-icon invest-icon6"></div>
                        <div class="invest-title">{{ $t('lp-grace25') }}</div>
                        <div class="invest-text">{{ $t('lp-grace26') }}</div>
                    </div>
                </div>

                <div class="invest-row">
                    <div class="invest-box">
                        <div class="invest-icon invest-icon7"></div>
                        <div class="invest-title">{{ $t('lp-grace27') }}</div>
                        <div class="invest-text">{{ $t('lp-grace28') }}</div>
                    </div>
                    <div class="invest-box">
                        <div class="invest-icon invest-icon8"></div>
                        <div class="invest-title">{{ $t('lp-grace29') }}</div>
                        <div class="invest-text">{{ $t('lp-grace30') }}</div>
                    </div>
                    <div class="invest-box">
                        <div class="invest-icon invest-icon9"></div>
                        <div class="invest-title">{{ $t('lp-grace31') }}</div>
                        <div class="invest-text">{{ $t('lp-grace32') }}</div>
                    </div>
                </div>
            </div>
            <div class="mobileapp-container" v-else>
                <h2 class="home-title-wine">{{ $t('lp-grace14') }}</h2>

                <swiper :options="swiperOptionMobile">
                    <swiper-slide v-for="(item, index) in swiperData2" :key="index">
                        <div class="invest-box">
                            <div :class="'invest-icon invest-icon' + item.name"></div>
                            <div class="invest-title" v-html="item.article"></div>
                            <div class="invest-text" v-html="item.value"></div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapGetters} from "vuex";
    import {GCommon} from "@/store/getters";
    import {directive, Swiper, SwiperSlide} from "vue-awesome-swiper";
    import 'swiper/css/swiper.css'

    export default {
        name: "LpGraceClub",
        head: {
            title: 'Wine investment made easy | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-landing-grace'
            }
        },
        computed: {
            ...mapGetters({
                mobileCheck: GCommon.GET_MOBILE_VERSION
            })
        },
        components: {
            Swiper,
            SwiperSlide
        },
        directives: {
            swiper: directive
        },
        data () {
            return {
                swiperOption: {
                    slidesPerView: 3,
                    spaceBetween: 60,
                    loop: false
                },
                swiperOptionMobile: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: false
                    }
                },
                swiperData: [
                    {
                        name: 'vanityfair',
                        article: 'VanityFair',
                        value: 'Wine is a medium to long term investment. We are talking about an average of 5 years even if it is possible to make punctual operations in the short term'
                    },
                    {
                        name: 'vice',
                        article: 'vice',
                        value: 'How to invest in wine if you\'re not a millionaire'
                    },
                    {
                        name: 'businessinsider',
                        article: 'BusinessInsider',
                        value: 'Vindome, the app for investing in the 5.1 billion dollar fine wine market. They have change the approach to fine wine investments and solve all previous issues connected to it, specially for the beginner collector'
                    }
                ],
                swiperDataIT: [
                    {
                        name: 'vice',
                        article: 'vice',
                        value: 'Come diventare ricchi – o almeno provarci – con il vino'
                    },
                    {
                        name: 'businessinsider',
                        article: 'BusinessInsider',
                        value: 'Vindome, l’app per investire sui vini pregiati: un mercato da 5,1 milliardi di dollari'
                    },
                    {
                        name: 'dagospia',
                        article: 'dagospia',
                        value: 'Ma quale Bitcoin! Il vero investimento è il vino! Arriva Vindome, l’app per fare trading con le bottiglie da collezione'
                    }
                ],
                swiperData2: [
                    {
                        name: '1',
                        article: this.$i18n.t('lp-grace15'),
                        value: this.$i18n.t('lp-grace16')
                    },
                    {
                        name: '2',
                        article: this.$i18n.t('lp-grace17'),
                        value: this.$i18n.t('lp-grace18')
                    },
                    {
                        name: '3',
                        article: this.$i18n.t('lp-grace19'),
                        value: this.$i18n.t('lp-grace20')
                    }
                ]
            }
        },
        methods: {
            storeClick(isAppStore) {
                this.$gtm.push({ event: isAppStore ? "AppStoreClick" : "GooglePlayClick" });
            },
            goToDownload() {
                window.scrollTo({
                    top: 370,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            showPrivacy: function(article){
                if (article === 'dagospia') {
                    window.open('https://m.dagospia.com/ma-quale-bitcoin-il-vero-investimento-sicuro-e-il-vinoarriva-vindome-l-app-per-fare-254689');
                } else if (article === 'jamesmagazine') {
                    window.open('https://www.jamesmagazine.it/news/vindome-lapp-investe-sui-vini-pregiati/');
                } else if (article === 'vice') {
                    window.open('https://www.vice.com/it/article/k7anww/guadagnare-con-il-vino');
                } else {
                    window.open(`https://vindome.net/Vindome_${article}.pdf`);
                }
            }
        }
    }
</script>

<style scoped>
    .last-section {
        margin-bottom: 48px;
    }
    .grace-container {
        padding-top: 80px;
    }
    .invest-row {
        margin: 0 104px;
    }
    .invest-box {
        display: inline-block;
        width: calc((100% - 104px) / 3);
        height: 253px;
        margin-bottom: 48px;
        background: #FFFFFF;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.16);
        border-radius: 16px;
        vertical-align: top;
    }
    .invest-row > .invest-box:nth-child(1),
    .invest-row > .invest-box:nth-child(2) {
        margin-right: 48px;
    }
    .invest-icon {
        width: 56px;
        height: 56px;
        margin: 16px auto 24px;
    }
    .invest-icon1 {
        background: url('../assets/landing/grace/icon5.png') no-repeat center;
    }
    .invest-icon2 {
        background: url('../assets/landing/grace/icon6.png') no-repeat center;
    }
    .invest-icon3 {
        background: url('../assets/landing/grace/icon7.png') no-repeat center;
    }
    .invest-icon4 {
        background: url('../assets/landing/grace/icon8.png') no-repeat center;
    }
    .invest-icon5 {
        background: url('../assets/landing/grace/icon9.png') no-repeat center;
    }
    .invest-icon6 {
        background: url('../assets/landing/grace/icon10.png') no-repeat center;
    }
    .invest-icon7 {
        background: url('../assets/landing/grace/icon11.png') no-repeat center;
    }
    .invest-icon8 {
        background: url('../assets/landing/grace/icon12.png') no-repeat center;
    }
    .invest-icon9 {
        background: url('../assets/landing/grace/icon13.png') no-repeat center;
    }
    .footer-logo-grace {
        width: 326px;
        height: 96px;
        margin: 48px auto 0;
        background: url('../assets/landing/grace/grace.png') no-repeat center;
    }
    .footer-logo-vindome {
        width: 330px;
        height: 77px;
        margin: 0 auto 48px;
        background: url('../assets/landing/grace/v.png') no-repeat center;
    }
    .footer-logo-dash {
        background: rgba(0, 0, 0, 0.12);
        height: 2px;
        width: 533px;
        margin: 32px auto;
    }
    .footer-description-text {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        max-width: 556px;
        margin: 0 auto;
        color: rgba(0, 0, 0, 0.88);
    }
    .footer-description-text1 {
        margin: 0 auto 48px;
    }
    .invest-title {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 29px;
        text-align: center;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 24px;
        padding: 0 8px;
    }
    .invest-text {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        padding: 0 16px;
        color: rgba(0, 0, 0, 0.64);
    }
    .start-btn {
        height: 40px;
        background: #004F7F;
        border-radius: 4px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        text-transform: uppercase;
        color: #FFFFFF;
        padding: 12px 16px;
        margin: 48px auto;
        max-width: 243px;
    }
    .start-btn:hover {
        cursor: pointer;
        background: #e6c67c;
    }
    .how-it-works-row {
        height: 116px;
    }
    .dash {
        width: 2px;
        height: 48px;
        background: #004F7F;
        margin: 16px auto;
    }
    .how-it-works-row-center {
        width: 116px;
        height: 116px;
        margin: 0 48px;
    }
    .how-it-works-row-left,
    .how-it-works-row-center,
    .how-it-works-row-right {
        display: inline-block;
    }
    .how-it-works-row-left,
    .how-it-works-row-right {
        width: calc((100% - 220px) / 2);
        height: 116px;
        vertical-align: top;
    }
    .how-it-works-row-right {
        text-align: left;
    }
    .how-it-works-row-left {
        text-align: right;
    }
    .icon1 {
        background: url('../assets/landing/grace/icon1.png') no-repeat center;
    }
    .icon2 {
        background: url('../assets/landing/grace/icon2.png') no-repeat center;
    }
    .icon3 {
        background: url('../assets/landing/grace/icon3.png') no-repeat center;
    }
    .icon4 {
        background: url('../assets/landing/grace/icon4.png') no-repeat center;
    }
    .how-title {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 29px;
        color: rgba(0, 0, 0, 0.88);
        max-width: 394px;
    }
    .how-title1 {
        margin-top: 12px;
    }
    .how-subtitle {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.64);
        max-width: 394px;
        margin-top: 16px;
    }
    .how-it-works-row-left .how-title,
    .how-it-works-row-left .how-subtitle {
        margin-left: calc(100% - 394px);
    }
    .featured {
        background-color: #f6f6f6;
        padding: 1px;
    }
    .vindome-app-icon {
        width: 118px;
        height: 117px;
        position: absolute;
        bottom: -59px;
        margin: 0 auto;
        left: 0;
        right: 0;
        background: url('../assets/landing/vlogo.png') no-repeat center;
    }
    .home-download-android,
    .home-download-ios {
        display: inline-block;
        width: 163px;
        height: 48px;
    }
    .home-download-ios {
        background: url('../assets/app/appstore.png') no-repeat center;
        width: 144px;
        margin-right: 16px;
    }
    .home-download-android {
        background: url('../assets/app/gplay.png') no-repeat center;
    }
    .home-download-android:hover,
    .home-download-ios:hover {
        cursor: pointer;
    }
    .download-btn-wrapper {
        margin: 50px auto 0;
        text-align: center;
    }
    .main-subtitle {
        max-width: 480px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 25px;
        line-height: 120%;
        text-align: center;
        color: #000000;
        margin: 88px auto 18px;
    }
    .download-btn-wrapper {
        margin: 0 auto 50px;
        text-align: center;
    }
    .home-download-android,
    .home-download-ios {
        display: inline-block;
        width: 163px;
        height: 48px;
    }
    .home-download-ios {
        background: url('../assets/app/appstore.png') no-repeat center;
        width: 144px;
        margin-right: 16px;
    }
    .home-download-android {
        background: url('../assets/app/gplay.png') no-repeat center;
    }
    .home-download-android:hover,
    .home-download-ios:hover {
        cursor: pointer;
    }
    .slogan {
        height: 672px;
        position: relative;
    }
    .slogan-img {
        background: url('../assets/landing/grace_back.jpg') no-repeat center top;
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    .main-title-wrapper {
        position: absolute;
        top: 96px;
        width: 1366px;
        height: calc(100% - 96px);
        max-width: 100%;
        left: 0;
        right: 0;
        margin: 0 auto;
        padding: 0 15px;
    }
    .main-title {
        width: 100%;
        height: 51px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 42px;
        line-height: 51px;
        display: block;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
        margin-bottom: 40px;
    }
    h2 {
        color: #707070;
        margin-bottom: calc(2*var(--gutter));
    }
    .home-title-wine {
        text-align: center;
        margin: 61px auto;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 39.06px;
        line-height: 120%;
        color: #303030;
    }
    .mobileapp-testimonials {
        background: #F6F6F6;
        height: 488px;
    }
    .mobileapp-testimonials .contactus-title2 {
        padding-top: 44px;
        margin-top: 0;
    }
    .testimonial-text {
        max-width: 1024px;
        margin: 0 auto;
        font-size: 17px;
        line-height: 22px;
    }
    .testimonial-name {
        color: #303030;
        font-weight: 700;
        font-size: 14px;
    }
    .testimonial-logo {
        width: 161px;
        height: 89px;
        margin: 0 auto 19px;
    }
    .logo-decanter {
        background: url('../assets/app/decanter.png') no-repeat center;
    }
    .logo-winespectator {
        background: url('../assets/app/winespectator.png') no-repeat center;
    }
    .logo-saveur {
        background: url('../assets/app/saveur.png') no-repeat center;
    }

    .logo-larepubblica {
        background: url('../assets/app/larepubblica.png') no-repeat center;
        background-size: contain;
    }
    .logo-ilgiornale {
        background: url('../assets/app/ilgiornale.png') no-repeat center;
        background-size: contain;
    }
    .logo-businessinsider {
        background: url('../assets/app/businessinsider.png') no-repeat center;
        background-size: contain;
    }
    .logo-cosmopolitan {
        background: url('../assets/app/cosmopolitan.png') no-repeat center;
        background-size: contain;
    }
    .logo-digitalclub {
        background: url('../assets/app/digitalclub.png') no-repeat center;
        background-size: contain;
    }
    .logo-mixerplanet {
        background: url('../assets/app/mixerplanet.png') no-repeat center;
        background-size: contain;
    }
    .logo-igrandivini {
        background: url('../assets/app/igrandivini.png') no-repeat center;
        background-size: contain;
    }
    .logo-vanityfair {
        background: url('../assets/app/vanityfair.svg') no-repeat center;
        background-size: contain;
    }
    .logo-winenews {
        background: url('../assets/app/winenews.png') no-repeat center;
        background-size: contain;
    }
    .logo-dagospia {
        background: url('../assets/app/dagospia.png') no-repeat center;
        background-size: contain;
    }
    .logo-vice {
        background: url('../assets/app/vice.svg') no-repeat center;
        background-size: contain;
    }
    .logo-rssmagazine {
        background: url('../assets/app/rss.png') no-repeat center;
        background-size: contain;
    }
    .logo-startup {
        background: url('../assets/app/startup.png') no-repeat center;
        background-size: contain;
    }
    .logo-jamesmagazine {
        background: url('../assets/app/jamesmagazine.png') no-repeat center;
        background-size: contain;
    }
    .testimonial-info {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 19px;
        line-height: 120%;
        color: #303030;
        text-align: center;
    }
    .mobileapp-container {
        max-width: 1366px;
        margin: 0 auto;
    }

    @media (max-width: 767px) {
        .last-section {
            margin-bottom: 0;
        }
        .main-subtitle {
            margin-top: 56px;
            margin-bottom: 48px;
            font-size: 18px;
            line-height: 120%;
            padding: 0 16px;
        }
        .download-btn-wrapper {
            margin-bottom: 40px;
        }
        .grace-container {
            padding-top: 40px;
        }
        .slogan {
            height: 375px;
        }
        .vindome-app-icon {
            height: 64px;
            width: 64px;
            bottom: -32px;
            background-size: contain;
        }
        .main-title {
            font-size: 24px;
            line-height: 100%;
        }
        .main-title-wrapper {
            top: 24px;
        }
        .home-title-wine {
            font-size: 18px;
            line-height: 120%;
            font-weight: 400;
            margin: 41px auto;
            padding: 0 20px;
            max-width: 335px;
        }
        .footer-logo-grace {
            width: 237px;
            height: 70px;
            background-size: contain;
        }
        .footer-logo-vindome {
            width: 239px;
            height: 56px;
            background-size: contain;
        }
        .footer-description-text {
            padding: 0 16px;
        }
        .footer-logo-dash {
            max-width: calc(100% - 32px);
            margin: 32px 16px;
        }
        .how-it-works-row-center {
            margin: 0 auto;
            display: block;
        }
        .how-title {
            margin: 16px auto;
            display: block;
            text-align: center;
        }
        .how-subtitle {
            margin: 0 auto;
            display: block;
            text-align: center;
        }
        .invest-box {
            width: calc(100% - 32px);
            margin: 0 16px;
        }
    }
</style>
<style>
    .page-landing-grace .v-main {
        padding-top: 0 !important;
    }
    .page-landing-grace .theme--dark.v-sheet.header-toolbar .logo img {
        margin-top: 20px;
    }
    .page-landing-grace .navs-list.site-navigation,
    .page-landing-grace .nav-first-row-right {
        display: none;
    }
    .page-landing-grace .locale-changer .navs-list.site-navigation {
        display: block;
    }
    .page-landing-grace .locale-changer {
        position: absolute;
        top: 25px;
        right: 30px;
    }
    .page-landing-grace .locale-changer .lang-nav:hover .submenu {
        right: 10px;
    }
    .page-landing-grace .flex {
        margin-top: 10px;
        text-align: left;
        position: relative;
    }
    .page-landing-grace .v-text-field__details {
        bottom: -7px;
        position: absolute;
    }
    .page-landing-grace .v-input input {
        height: 40px;
        max-height: unset;
        margin-top: 4px;
        padding-left: 15px;
    }
    .page-landing-grace .v-text-field .v-input__append-inner {
        margin-top: 4px;
        background: #fff;
        height: 40px;
    }
    .page-landing-grace .v-text-field .v-input__append-inner .v-input__icon {
        margin-top: 8px;
        margin-right: 3px;
    }
    .page-landing-grace .v-text-field .v-input__append-inner .primary--text {
        color: #000 !important;
        caret-color: #000 !important;
    }
    .page-landing-grace .theme--light.v-input:not(.v-input--is-disabled) input {
        border: 0;
    }
    .page-landing-grace .theme--light.v-text-field:not(.v-input--has-state)>.v-input__control>.v-input__slot:hover:before {
        border-color: var(--brand);
    }
    .page-landing-grace .theme--light.v-text-field>.v-input__control>.v-input__slot:after {
        border-color: rgba(0,0,0,.87);
        border-width: 1px;
    }
    .page-landing-grace .theme--light.v-text-field.error--text>.v-input__control>.v-input__slot:after {
        border-color: #ff5252;
    }
    .page-landing-grace .footer-links a,
    .page-landing-grace .check-terms a {
        text-decoration: none;
        color: #707070;
        font-size: 19px;
        font-weight: 300;
    }
    .page-landing-grace .footer-links a:hover,
    .page-landing-grace .check-terms a:hover {
        color: var(--brand);
    }
    .theme--light.v-application.loginpage {
        background: #ffffff;
    }
    .page-landing-grace .v-input--checkbox .v-messages {
        display: none;
    }

    .page-landing-grace .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 6px;
    }
    .page-landing-grace .v-input input[type=checkbox] {
        width: 18px;
        height: 18px;
    }

    .page-landing-grace .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot .v-icon.v-icon {
        font-size: 18px;
    }

    .page-landing-grace .v-input--selection-controls__input {
        margin-right: 0;
    }

    .page-landing-grace .v-input--selection-controls.v-input .v-label {
        font-size: 12px;
    }

    .page-landing-grace .v-application .accent--text {
        color: #E2C477 !important;
        caret-color: #E2C477 !important;
    }

    .swiper-container {
        margin: 0 auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        height: 300px;
        width: 100%;
    }
    .show-mobile .swiper-container {
        height: 360px;
    }
    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform;
        box-sizing: content-box;
    }

    .swiper-container-no-flexbox .swiper-slide {
        float: left
    }

    .swiper-container-vertical>.swiper-wrapper {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column
    }

    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform;
        box-sizing: content-box
    }

    .swiper-container-android .swiper-slide,.swiper-wrapper {
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
    }

    .swiper-container-multirow>.swiper-wrapper {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap
    }

    .swiper-container-free-mode>.swiper-wrapper {
        transition-timing-function: ease-out;
        margin: 0 auto
    }

    .swiper-slide {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform
    }

    .swiper-slide.swiper-slide-active .testimonial-item {
        border-right: 1px solid #F0F0F0;
        padding-left: 0;
        padding-right: 45px;
    }

    .show-mobile .swiper-slide.swiper-slide-active .testimonial-item {
        border-right: 0;
        padding-right: 0;
    }

    .swiper-invisible-blank-slide {
        visibility: hidden
    }

    .swiper-container-autoheight,.swiper-container-autoheight .swiper-slide {
        height: auto
    }

    .swiper-container-autoheight .swiper-wrapper {
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        transition-property: height,-webkit-transform;
        transition-property: transform,height;
        transition-property: transform,height,-webkit-transform
    }

    .swiper-container-3d {
        -webkit-perspective: 1200px;
        perspective: 1200px
    }

    .swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper {
        -webkit-transform-style: preserve-3d;
        transform-style: preserve-3d
    }

    .swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 10
    }

    .swiper-container-3d .swiper-slide-shadow-left {
        background-image: linear-gradient(270deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-right {
        background-image: linear-gradient(90deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-top {
        background-image: linear-gradient(0deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-bottom {
        background-image: linear-gradient(180deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-wp8-horizontal,.swiper-container-wp8-horizontal>.swiper-wrapper {
        -ms-touch-action: pan-y;
        touch-action: pan-y
    }

    .swiper-container-wp8-vertical,.swiper-container-wp8-vertical>.swiper-wrapper {
        -ms-touch-action: pan-x;
        touch-action: pan-x
    }

    .swiper-button-next,.swiper-button-prev {
        position: absolute;
        top: 50%;
        width: 27px;
        height: 44px;
        margin-top: -22px;
        z-index: 10;
        cursor: pointer;
        background-size: 27px 44px;
        background-position: 50%;
        background-repeat: no-repeat
    }

    .swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled {
        opacity: .35;
        cursor: auto;
        pointer-events: none
    }

    .swiper-button-prev,.swiper-container-rtl .swiper-button-next {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E");
        left: 50px;
        right: auto
    }

    .swiper-button-next,.swiper-container-rtl .swiper-button-prev {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E");
        right: 50px;
        left: auto
    }

    .swiper-button-prev.swiper-button-white,.swiper-container-rtl .swiper-button-next.swiper-button-white {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E")
    }

    .swiper-button-next.swiper-button-white,.swiper-container-rtl .swiper-button-prev.swiper-button-white {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E")
    }

    .swiper-button-prev.swiper-button-black,.swiper-container-rtl .swiper-button-next.swiper-button-black {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E")
    }

    .swiper-button-next.swiper-button-black,.swiper-container-rtl .swiper-button-prev.swiper-button-black {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E")
    }

    .swiper-pagination {
        position: absolute;
        text-align: center;
        transition: opacity .3s;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        z-index: 10
    }

    .swiper-pagination.swiper-pagination-hidden {
        opacity: 0
    }

    .swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
        bottom: 10px;
        left: 0;
        width: 100%
    }

    .carousel-wrapper {
        height: 480px;
        position: relative;
    }

    @media (max-width: 767px) {
        .swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
            bottom: 0;
        }
    }

    .swiper-pagination-bullets-dynamic {
        overflow: hidden;
        font-size: 0
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        -webkit-transform: scale(.33);
        transform: scale(.33);
        position: relative
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
        -webkit-transform: scale(1);
        transform: scale(1)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
        -webkit-transform: scale(.66);
        transform: scale(.66)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
        -webkit-transform: scale(.33);
        transform: scale(.33)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
        -webkit-transform: scale(.66);
        transform: scale(.66)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
        -webkit-transform: scale(.33);
        transform: scale(.33)
    }

    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        display: inline-block;
        border-radius: 100%;
        background: #000;
        opacity: .2
    }

    button.swiper-pagination-bullet {
        border: none;
        margin: 0;
        padding: 0;
        box-shadow: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none
    }

    .swiper-pagination-clickable .swiper-pagination-bullet {
        cursor: pointer
    }

    .swiper-pagination-bullet-active {
        opacity: 1;
        background: #007aff
    }

    .swiper-container-vertical>.swiper-pagination-bullets {
        right: 10px;
        top: 50%;
        -webkit-transform: translate3d(0,-50%,0);
        transform: translate3d(0,-50%,0)
    }

    .swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 6px 0;
        display: block
    }

    .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 8px
    }

    .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        display: inline-block;
        transition: top .2s,-webkit-transform .2s;
        transition: transform .2s,top .2s;
        transition: transform .2s,top .2s,-webkit-transform .2s
    }

    .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 0 4px
    }

    .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        white-space: nowrap
    }

    .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: left .2s,-webkit-transform .2s;
        transition: transform .2s,left .2s;
        transition: transform .2s,left .2s,-webkit-transform .2s
    }

    .swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: right .2s,-webkit-transform .2s;
        transition: transform .2s,right .2s;
        transition: transform .2s,right .2s,-webkit-transform .2s
    }

    .swiper-pagination-progressbar {
        background: rgba(0,0,0,.25);
        position: absolute
    }

    .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
        background: #007aff;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        -webkit-transform: scale(0);
        transform: scale(0);
        -webkit-transform-origin: left top;
        transform-origin: left top
    }

    .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
        -webkit-transform-origin: right top;
        transform-origin: right top
    }

    .swiper-container-horizontal>.swiper-pagination-progressbar {
        width: 100%;
        height: 4px;
        left: 0;
        top: 0
    }

    .swiper-container-vertical>.swiper-pagination-progressbar {
        width: 4px;
        height: 100%;
        left: 0;
        top: 0
    }

    .swiper-pagination-white .swiper-pagination-bullet-active {
        background: #fff
    }

    .swiper-pagination-progressbar.swiper-pagination-white {
        background: hsla(0,0%,100%,.25)
    }

    .swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {
        background: #fff
    }

    .swiper-pagination-black .swiper-pagination-bullet-active {
        background: #000
    }

    .swiper-pagination-progressbar.swiper-pagination-black {
        background: rgba(0,0,0,.25)
    }

    .swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {
        background: #000
    }

    .swiper-scrollbar {
        border-radius: 10px;
        position: relative;
        -ms-touch-action: none;
        background: rgba(0,0,0,.1)
    }

    .swiper-container-horizontal>.swiper-scrollbar {
        position: absolute;
        left: 1%;
        bottom: 3px;
        z-index: 50;
        height: 5px;
        width: 98%
    }

    .swiper-container-vertical>.swiper-scrollbar {
        position: absolute;
        right: 3px;
        top: 1%;
        z-index: 50;
        width: 5px;
        height: 98%
    }

    .swiper-scrollbar-drag {
        height: 100%;
        width: 100%;
        position: relative;
        background: rgba(0,0,0,.5);
        border-radius: 10px;
        left: 0;
        top: 0
    }

    .swiper-scrollbar-cursor-drag {
        cursor: move
    }

    .swiper-zoom-container {
        width: 100%;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center
    }

    .swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg {
        max-width: 100%;
        max-height: 100%;
        -o-object-fit: contain;
        object-fit: contain
    }

    .swiper-slide-zoomed {
        cursor: move
    }

    .swiper-lazy-preloader {
        width: 42px;
        height: 42px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -21px;
        margin-top: -21px;
        z-index: 10;
        -webkit-transform-origin: 50%;
        transform-origin: 50%;
        -webkit-animation: swiper-preloader-spin 1s steps(12) infinite;
        animation: swiper-preloader-spin 1s steps(12) infinite
    }

    .swiper-lazy-preloader:after {
        display: block;
        content: "";
        width: 100%;
        height: 100%;
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
        background-position: 50%;
        background-size: 100%;
        background-repeat: no-repeat
    }

    .swiper-lazy-preloader-white:after {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E")
    }

    @-webkit-keyframes swiper-preloader-spin {
        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
        }
    }

    @keyframes swiper-preloader-spin {
        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
        }
    }

    .swiper-container .swiper-notification {
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        opacity: 0;
        z-index: -1000
    }

    .swiper-container-fade.swiper-container-free-mode .swiper-slide {
        transition-timing-function: ease-out
    }

    .swiper-container-fade .swiper-slide {
        pointer-events: none;
        transition-property: opacity
    }

    .swiper-container-fade .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-cube {
        overflow: visible
    }

    .swiper-container-cube .swiper-slide {
        pointer-events: none;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 1;
        visibility: hidden;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        width: 100%;
        height: 100%
    }

    .swiper-container-cube .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-cube.swiper-container-rtl .swiper-slide {
        -webkit-transform-origin: 100% 0;
        transform-origin: 100% 0
    }

    .swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev {
        pointer-events: auto;
        visibility: visible
    }

    .swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top {
        z-index: 0;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden
    }

    .swiper-container-cube .swiper-cube-shadow {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: .6;
        -webkit-filter: blur(50px);
        filter: blur(50px);
        z-index: 0
    }

    .swiper-container-flip {
        overflow: visible
    }

    .swiper-container-flip .swiper-slide {
        pointer-events: none;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 1
    }

    .swiper-container-flip .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top {
        z-index: 0;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden
    }

    .swiper-container-coverflow .swiper-wrapper {
        -ms-perspective: 1200px
    }

    @media (max-width: 767px) {
        .page-landing-grace .locale-changer {
            position: absolute;
            top: 5px;
            right: 10px;
        }
        .page-landing-grace .v-application .hidden-md-and-up {
            display: none !important;
        }
        .page-landing-grace .theme--dark.v-sheet.header-toolbar,
        .page-landing-grace .theme--dark.v-sheet.header-toolbar .v-toolbar__content {
            height: 40px !important;
        }
        .page-landing-grace .theme--dark.v-sheet.header-toolbar .logo img {
            margin-left: 10px;
            margin-top: 3px;
        }
        .page-landing-grace .swiper-container {
            height: 390px;
        }
        .page-landing-grace .nav-second-row,
        .page-landing-grace .site-navigation-wrapper {
            display: block;
        }
        .page-landing-grace .main-footer {
            display: none;
        }
    }
</style>
